module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "cbg"
  }, [_c('p', {
    staticClass: "title1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('div', {
    staticClass: "cbg1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "cha"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "thl1a"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('i', [_vm._v("knit")])])]), _vm._v(" "), _c('p', {
    staticClass: "linebc"
  }), _c('p', {
    staticClass: "ch1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_vm._v("Key Lime Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_vm._v("Orangelo Bib")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paddington Coat")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Smocked” Cardigan")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battenberg Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kumquat Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Campus Onesie")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pomelo Slice")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compass Cap")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bobbled Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jet Age Cardigan")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moderne Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solaria Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rag Rug Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rivulet Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yuzu Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clementine Jumper")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ronald “Snowsuit”")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diamond Bunting")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terra Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calico Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bertie Bird")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Havilland Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuxedo Romper")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hike Hat")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scribble Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "thl1a"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('i', [_vm._v("crochet")])])]), _vm._v(" "), _c('p', {
    staticClass: "linebc"
  }), _c('p', {
    staticClass: "ch1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("Cleire Cardigan")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_vm._v("Darla Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snowflake Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slice Cap")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pink Lemonade Dress")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High Fidoodlity Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Citrus Grove Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abigail Bolero")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sideways Cardigan")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deanna Jumper")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judi Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterfly Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Limoges Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dickie Sweater")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday Best Dress")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Citron Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post & Beam Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camellia Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Aran” Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plié Cardigan")])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Limonia Caterpillar")])]), _vm._v(" "), _c('div', {
    staticClass: "cbg1"
  }, [_c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "cha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55_Special_Techniques",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Special Techniques")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d8d62fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Content.vue
// module id = 66
// module chunks = 0